module.exports = __webpack_public_path__ + "static/media/volume-high.60f86cb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/volume-high.svg
// module id = 3784
// module chunks = 7